<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
  >
    <g>
      <path
        :fill="color"
        d="M6.95 5.736l3.724-3.725a.592.592 0 1 0-.837-.837L6.112 4.898 2.387 1.174a.592.592 0 1 0-.837.837l3.724 3.725L1.55 9.46a.592.592 0 1 0 .837.838l3.725-3.725 3.725 3.725a.59.59 0 0 0 .837 0 .592.592 0 0 0 0-.838z"
      />
      <path
        fill="none"
        :stroke="color"
        stroke-miterlimit="50"
        d="M6.95 5.736v0l3.724-3.725a.592.592 0 1 0-.837-.837L6.112 4.898v0L2.387 1.174a.592.592 0 1 0-.837.837l3.724 3.725v0L1.55 9.46a.592.592 0 1 0 .837.838l3.725-3.725v0l3.725 3.725a.59.59 0 0 0 .837 0 .592.592 0 0 0 0-.838z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#f31357',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
